import { tasksStatuses } from 'components/root/Container/Layout/Tasks/Task/taskConstants';

export const UNASSIGNED_ASSIGNEE = { id: 'Unassigned', name: 'Unassigned' };

export const INITIAL_FILTERS_STATE = {
  statuses: {
    source: [...tasksStatuses],
    value: [...tasksStatuses]
  },
  topics: {
    source: [],
    value: []
  },
  ssu: {
    studySites: [],
    studies: [],
    sites: [],
    selectedStudyMap: {},
    selectedSiteMap: {},
    selectedStudies: [],
    selectedSites: []
  },
  assignee: {
    source: [UNASSIGNED_ASSIGNEE],
    value: null
  }
};

export const INITIAL_GRID_STATE = {
  filter: { filterModel: { items: [], quickFilterExcludeHiddenColumns: false } },
  sorting: { sortModel: [{ field: 'dueDate', sort: 'asc' }] }
};

export const TASK_WORKLIST = 'TASK_WORKLIST';
export const TASK_WORK_LIST_TABLE_KEY = 'TASK_WORKLIST_TABLE';
